import { IAHU } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

type AHUState = {
  editAHU: IAHU;
  updateDeleteAHU: boolean;
};

const getEditAHU = (state: AHUState) => {
  return state.editAHU;
};

const getAHUUpdateDelete = (state: AHUState) => {
  return state.updateDeleteAHU;
};

export default {
  getEditAHU,
  getAHUUpdateDelete,
};
